import React from 'react'
import BlogPage from '../components/BlogPage/BlogPage'
import Header from '../components/Header/Header'

function Contact() {
  return (
    <div>
      <Header />
      <BlogPage />
    </div>
  )
}

export default Contact